import { useEffect, useMemo, useState } from "react";

const _sw_firebase_messaging = 'firebase-messaging-sw.js';

export const _appVersion = '3.2.4.1';

export const useServiceWorker = (serviceWorkerReady) => {

  const [registration, setRegistration] = useState(null);
  const [registrationError, setRegistrationError] = useState(null);
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [newVersionNumber, setNewVersionNumber] = useState();

  useEffect(() => {

    if (!serviceWorkerReady) return;
    if (!('serviceWorker' in navigator)) return;

    const register = async () => {

      try {

        const reg = await navigator.serviceWorker.register(
          `${process.env.PUBLIC_URL}/${_sw_firebase_messaging}`
        );

        setRegistration(reg);

        if (reg.waiting) {
          console.log('⌛ New Version Available')
          setNewVersionAvailable(true);
          setNewVersionNumber(_appVersion)
        }

        reg.addEventListener('updatefound', () => {

          const newWorker = reg.installing;

          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {

            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              setNewVersionAvailable(true);
              setNewVersionNumber(_appVersion)
            }
          });

        });

        // Check immediately for a newer service worker
        await reg.update();

      } catch (error) {

        setRegistrationError(error);
        console.error('Service worker registration', error);

      }

    };

    register();

  }, [serviceWorkerReady]);

  useEffect(() => {

    const handleControllerChange = () => {
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener(
      'controllerchange',
      handleControllerChange
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        'controllerchange',
        handleControllerChange
      );
    };

  }, []);

  const updateRegistration = () => {
    console.log('registration', registration);
    console.log('waiting', registration?.waiting);
    if (registration?.waiting) {
      registration.waiting.postMessage({
        type: 'SKIP_WAITING'
      });
    }
  };

  return useMemo(() => ({
    registration,
    registrationError,
    newVersionAvailable,
    newVersionNumber,
    updateRegistration,
  }), [
    registration,
    registrationError,
    newVersionAvailable,
    newVersionNumber,
  ]);

};